const protocol = [
    {
        title: 'Sign up for a gift',
        lines: [
            '- The giveaway is open only to visitors of CES 2025 (January 7–10, 2025) who visit EcoFlow booths #31100, South Hall 1 or #20344, Central Hall.',
            '- Each participant can receive one EcoFlow Scarf only by signing up with their email on the designated page of the EcoFlow website and visiting the EcoFlow booth.',
            '- The EcoFlow Scarfs are limited in quantity and will be distributed on a first-come, first-served basis.',
            '- Participants must be 18 years or older to be eligible for the EcoFlow Scarf.',
            '- EcoFlow reserves the right to change, amend, or cancel the giveaway at any time without prior notice.',
            '- By participating, you agree to the collection and use of your personal data in accordance with EcoFlow’s Privacy Policy.',
        ],
    },
    {
        title: 'CES 2025 Deals',
        lines: [
            '- CES 2025 Deals are valid exclusively from January 7–10, 2025 (PST) on <a href="https://ecoflow.com" target="_blank">ecoflow.com</a>.',
            '- Each order qualifies for limited-time discounts on selected products and a free charger, redeemable on-site at CES 2025.',
            '- Free chargers are available in limited quantities and will be distributed on a first-come, first-served basis while supplies last.',
            '- Only orders placed during CES 2025 (January 7–10, 2025) and completed through <a href="https://ecoflow.com" target="_blank">ecoflow.com</a> are eligible for a free charger.',
            '- To redeem the free charger, you must:',
            '  - Present your order confirmation(digital) at one of the EcoFlow booths (#31100, South Hall 1, or #20344, Central Hall).',
            '  - Chargers must be redeemed in person during CES 2025 event hours.',
            '  - Unclaimed chargers will not be shipped or reserved after CES 2025 ends.',
        ],
    },
];

export default protocol;
